export const CONVERSATIONS_CHANGED = 'softai:conversations-changed';

export const notifyConversationsChanged = () => {
	window.dispatchEvent(new CustomEvent(CONVERSATIONS_CHANGED));
};
